var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDone(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.319 7.17l-1.402-1.442a.302.302 0 00-.224-.095.29.29 0 00-.223.095l-9.722 9.794-3.538-3.538a.315.315 0 00-.223-.096c-.08 0-.16.032-.223.096l-1.418 1.418a.318.318 0 000 .455l4.462 4.462c.287.287.638.454.932.454.423 0 .79-.31.925-.438h.008l10.654-10.71c.112-.135.112-.335-.008-.454z"
  })));
}
export default SvgDone;